import { MutableRefObject, RefCallback, useCallback } from 'react';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';
export function useMergedRefs<T>(...refs: Array<RefCallback<T> | MutableRefObject<T | null> | null | undefined>): RefCallback<T> {
  const refsRef = useRefWithCurrentValue(refs);
  return useCallback<RefCallback<T>>(instance => {
    for (const ref of refsRef.current) {
      if (!ref) {
        continue;
      }
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  }, [refsRef]);
}